import RadioButtonGroup from '@/common/ant-components/RadioGroupReport';
// import { periodArrayEnglish } from '@/common/custom-date-selector/helpers';
import useAppData from '@/hooks/useAppData';
import { Button, ConfigProvider, Divider, Form, Popover } from 'antd';
import {
  // disableDateBetween,
  getAdFromBS,
  getAdFromBSInYMD,
  getBsFromAD,
  periodArrayNepali,
  // userData,
} from '../helpers';
import { useLocation } from 'react-router-dom';
import { getTodayDate } from '../helpers';
import { NewNepaliDatePicker } from '@/common/customNepaliDatePicker';
import { CalendarOutlined } from '@ant-design/icons';
import { AntButton } from '@/common/ant-components/AntButton';
import { useEffect, useState } from 'react';
import { NewNepaliDatePickerWithDynamicData } from '@/common/customNepaliDatePickerWithDynamicData';

interface Props {
  radioButtonProps: {
    onChange: (e: any) => void;
    initialValue: any;
    name: string;
  };
  form: any;
  dateType: string;
  customDateSelectorPropsNepali: {
    periodValueList: any;
    setPeriodValueList: (data: any) => void;
    dateType: string;
    setDateType: (data: string) => void;
    setStartDate: (data: string | null) => void;
    setEndDate: (data: string | null) => void;
    setSalesStartDate: (data: any) => void;
    setSalesEndDate: (data: any) => void;
    selectedPeriodList: any;
    setSelectedPeriodList: (data: any) => void;
  };
}

const DateChangeWithPopOverNepali: React.FC<Props> = (props) => {
  const {
    radioButtonProps,
    dateType,
    customDateSelectorPropsNepali,
    // form: formProp,
  } = props;
  const { onChange, initialValue, name } = radioButtonProps;
  const {
    periodValueList,
    setPeriodValueList,
    setStartDate,
    setEndDate,
    setSalesEndDate,
    setSalesStartDate,
    selectedPeriodList,
    setSelectedPeriodList,
  } = customDateSelectorPropsNepali;
  const form = Form.useFormInstance();
  const selectedPeriod = Form.useWatch('period', form);

  const [open, setPopOverOpen] = useState(false);

  const today = getTodayDate();

  const fromDateBsDummy = Form.useWatch('from_bs_dummy', form) || today;
  const toDateBsDummy = Form.useWatch('to_bs_dummy', form) || today;

  const { pathname } = useLocation();

  const { app } = useAppData();
  const isActive = app?.isActive;

  const customDateNepali = [
    {
      label: 'Custom',
      value: 'Custom',
      from: {
        date: isActive
          ? getBsFromAD(app?.financialStartYear)
          : getBsFromAD(app?.financialStartYear),
      },
      to: {
        date: isActive
          ? getBsFromAD(app?.financialEndYear)
          : getBsFromAD(app?.financialEndYear),
      },
    },
  ];

  const isCustomPeriod = selectedPeriod === 'Custom';

  const disabledDateBefore = isCustomPeriod
    ? getBsFromAD(app?.financialStartYear) || today
    : '';
  const disabledDateAfter = isCustomPeriod
    ? getBsFromAD(app?.financialEndYear) || today
    : '';

  const allDateNepali = {
    label: 'All',
    value: 'All',
    from: { date: getBsFromAD(app?.financialStartYear) },
    to: { date: getBsFromAD(app?.financialEndYear) },
  };

  const optionsArray = isActive
    ? [
        ...periodArrayNepali.map((item: any) => ({
          label: item.label,
          value: item.label,
          from: item.value.from,
          to: item.value.to,
        })),
      ]
    : [allDateNepali, ...customDateNepali];

  const onChangeNepaliDate = (text: string, option: any) => {
    form.setFieldValue('period', text);
    setPeriodValueList({
      ...periodValueList,
      [pathname]: text,
    });
    setSelectedPeriodList &&
      setSelectedPeriodList({
        ...selectedPeriodList,
        [pathname]: text ?? option?.label,
      });
    const startDateAd = getAdFromBS(option?.from?.date);
    const endDateAd = getAdFromBS(option?.to?.date);
    setStartDate && setStartDate(getAdFromBSInYMD(startDateAd));
    setEndDate && setEndDate(getAdFromBSInYMD(endDateAd));
    setSalesEndDate &&
      setSalesEndDate((prev: any) => ({
        ...prev,
        [pathname]: getAdFromBSInYMD(endDateAd),
      }));

    setSalesStartDate &&
      setSalesStartDate((prev: any) => ({
        ...prev,
        [pathname]: getAdFromBSInYMD(startDateAd),
      }));

    if (option?.value === 'Custom') {
      form.setFieldsValue({
        from_bs: getBsFromAD(app?.financialStartYear) || today,
        to_bs: getBsFromAD(app?.financialEndYear) || today,
        from_bs_dummy: getBsFromAD(app?.financialStartYear) || today,
        to_bs_dummy: getBsFromAD(app?.financialEndYear) || today,
      });
    } else {
      form.setFieldsValue({
        from_bs: option?.from?.date || '',
        to_bs: option?.to?.date || '',
        from_bs_dummy: option?.from?.date || '',
        to_bs_dummy: option?.to?.date || '',
      });
    }
  };

  const modifiledPeriodArray = [
    ...periodArrayNepali,
    {
      label: 'Custom',
      value: {
        from: (() => {
          return {
            date: isActive
              ? getBsFromAD(app?.financialStartYear)
              : getBsFromAD(app?.financialStartYear),
            dateTime: `${app?.financialStartYear}T00:00:00.000Z`,
          };
        })(),
        to: (() => {
          return {
            date: isActive
              ? getBsFromAD(app?.financialEndYear)
              : getBsFromAD(app?.financialEndYear),
            dateTime: `${app?.financialEndYear}T00:00:00.000Z`,
          };
        })(),
      },
    },
    {
      label: 'All',
      value: {
        from: (() => {
          return {
            date: getBsFromAD(app?.financialStartYear),
            dateTime: `${app?.financialStartYear}T00:00:00.000Z`,
          };
        })(),
        to: (() => {
          return {
            date: getBsFromAD(app?.financialEndYear),
            dateTime: `${app?.financialEndYear}T00:00:00.000Z`,
          };
        })(),
      },
    },
  ];

  useEffect(() => {
    if (selectedPeriod) {
      const periodObject = modifiledPeriodArray.find(
        (p) => p?.label?.toLowerCase() === selectedPeriod?.toLowerCase(),
      )?.value;

      if (selectedPeriod === 'Custom') {
        form.setFieldsValue({
          from_bs: getBsFromAD(app?.financialStartYear) || today,
          to_bs: getBsFromAD(app?.financialEndYear) || today,
          from_bs_dummy: getBsFromAD(app?.financialStartYear) || today,
          to_bs_dummy: getBsFromAD(app?.financialEndYear) || today,
        });
      } else {
        form.setFieldsValue({
          from_bs: periodObject?.from?.date || '',
          to_bs: periodObject?.to?.date || '',
          from_bs_dummy: periodObject?.from?.date || today,
          to_bs_dummy: periodObject?.to?.date || today,
        });
      }
    }
  }, [dateType, selectedPeriod]);

  const renderContent = (
    <div
      style={{
        maxWidth: 250,
        position: 'relative',
      }}
    >
      {/* <div className="tw-mb-2">
        <RadioButtonGroup
          name={name}
          initialValue={initialValue}
          onChange={onChange}
        />
      </div> */}

      {dateType === 'bs' ? (
        <>
          <Form.Item
            name="period"
            noStyle
            hidden
            initialValue={
              isActive
                ? periodValueList?.[pathname] || periodValueList?.defaultPeriod
                : 'All'
            }
          ></Form.Item>
          <Form.Item hidden name={'from_bs_dummy'}></Form.Item>
          <Form.Item hidden name={'to_bs_dummy'}></Form.Item>
          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />

          <div className="tw-grid tw-grid-cols-2 tw-gap-1">
            {optionsArray.map((option) => (
              <Button
                key={option.value}
                type={
                  // selectedPeriod === option.value ||
                  selectedPeriodList?.[pathname] === option.value
                    ? undefined
                    : 'dashed'
                }
                color="default"
                variant="outlined"
                onClick={() => {
                  onChangeNepaliDate(option.value, option);
                  setPopOverOpen(false);
                }}
              >
                {option.label}
              </Button>
            ))}
          </div>
          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />
          <div className="tw-grid tw-grid-cols-2 tw-gap-1">
            <div></div>
            <div className="tw-flex tw-justify-end tw-w-full">
              <RadioButtonGroup
                name={name}
                initialValue={initialValue}
                onChange={onChange}
              />
            </div>
          </div>
          {/* <Form.Item
            shouldUpdate={(prevValues, curValues) =>
              prevValues.from_ad !== curValues.from_ad ||
              prevValues.to_ad !== curValues.to_ad ||
              prevValues.from_ad_dummy !== curValues.from_ad_dummy ||
              prevValues.to_ad_dummy !== curValues.to_ad_dummy
            }
            noStyle
          >
            {() => {
              return ( */}
          <>
            <div className="md:tw-grid md:tw-grid-cols-2 tw-gap-x-2">
              <div>
                <NewNepaliDatePickerWithDynamicData
                  formProps={{
                    name: 'from_bs',
                    layout: 'vertical',
                    label: 'Custom',
                  }}
                  disabledBefore={disabledDateBefore}
                  disabledAfter={
                    toDateBsDummy || getBsFromAD(app?.financialEndYear)
                  }
                  onChange={(e) => {
                    if (!e) return;
                    form.setFieldsValue({
                      from_bs_dummy: e,
                    });
                  }}
                />
              </div>

              <div>
                <NewNepaliDatePickerWithDynamicData
                  formProps={{
                    name: 'to_bs',
                    layout: 'vertical',
                    label: ' ',
                  }}
                  disabledBefore={
                    fromDateBsDummy || getBsFromAD(app?.financialStartYear)
                  }
                  disabledAfter={disabledDateAfter}
                  onChange={(e) => {
                    if (!e) return;
                    form.setFieldsValue({
                      to_bs_dummy: e,
                    });
                  }}
                />
              </div>
            </div>
          </>
          {/* );
            }}
          </Form.Item> */}

          <Divider
            style={{
              padding: 0,
              margin: '10px 0',
            }}
          />
          <div className="tw-flex tw-justify-end">
            <Button
              onClick={() => {
                onChangeNepaliDate('Custom', {
                  label: 'Custom',
                  from: {
                    date: form.getFieldValue('from_bs') || today,
                  },
                  to: {
                    date: form.getFieldValue('to_bs') || today,
                  },
                });
                setPopOverOpen(false);
              }}
            >
              Apply
            </Button>
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={(visible) => setPopOverOpen(visible)}
      content={renderContent}
      title={
        <div
          style={{
            padding: '4px 0',
          }}
        >
          Date Filter
        </div>
      }
      trigger="click"
    >
      <AntButton
        // type="dashed"
        // variant="outlined"
        // color="default"
        // variant="outlined"
        // type={'dashed'}
        color="green"
        // variant="outlined"
        onClick={() => setPopOverOpen(!open)}
        icon={<CalendarOutlined className="tw-text-[0.95rem] tw-ms-1" />}
        iconPosition="end"
      >
        {/* {selectedPeriod || 'Today'} */}
        {selectedPeriodList?.[pathname] || selectedPeriod || 'Today'}
      </AntButton>
    </Popover>
  );
};
export default DateChangeWithPopOverNepali;
